import React from "react";
import Layout from "../layouts/Default";
import Input from "../components/inputs/Input";
import Textarea from "../components/inputs/Textarea";
import Select from "../components/selects/Select";
import TypesContext from "../contexts/types";
import AuthContext from "../contexts/auth";
import Checkbox from "../components/checkboxes/Checkbox";
import ImageBgUpload from "../components/uploads/ImageBgUpload.js";
import Button from "../components/buttons/Button";
import fetchApi from "../fetchApi";
const MIN_YEAR = 2000;
const MAX_YEAR = new Date().getFullYear();
const years = [];
for (let i = MAX_YEAR; i >= MIN_YEAR; i--) years.push({ label: i, value: i });

export default ({ history }) => {
  const { work = null } = history.location.state ? history.location.state : {};
  const { skills, months } = React.useContext(TypesContext);
  const [name, setName] = React.useState(work ? work.title.rendered : "");
  const [client, setClient] = React.useState(work ? work.client : "");
  const [videoUrl, setVideoUrl] = React.useState(work?.video_url || "");
  const [image0, setImage0] = React.useState(
    work?.image?.breakpoints
      ? work.image.base_path + work.image.breakpoints.xs["1x"]
      : null
  );
  const [image1, setImage1] = React.useState(
    work?.image2?.breakpoints
      ? work.image2.base_path + work.image2.breakpoints.xs["1x"]
      : null
  );
  const [image2, setImage2] = React.useState(
    work?.image3?.breakpoints
      ? work.image3.base_path + work.image3.breakpoints.xs["1x"]
      : null
  );
  const [description, setDescription] = React.useState(
    work ? work.description : ""
  );
  const [month, setMonth] = React.useState(
    work ? months.find(({ value }) => value === work.month) : null
  );
  const [year, setYear] = React.useState(
    work ? years.find(({ value }) => value === work.year) : null
  );
  const [selectedSkills, selectSkill] = React.useReducer(
    skillReducer,
    work && work.skill ? work.skill : []
  );
  const [loading, setLoading] = React.useState(false);
  const { user } = React.useContext(AuthContext);
  const [errors, setError] = React.useReducer(reduceError, []);

  const onPublish = async () => {
    setError();
    let isOkay = true;
    if (!name) {
      setError({ field: "name", message: "Missing name field" });
      isOkay = false;
    }
    if (!client) {
      setError({ field: "client", message: "Missing client field" });
      isOkay = false;
    }
    if (!month) {
      setError({ field: "month", message: "Missing month field" });
      isOkay = false;
    }
    if (!year) {
      setError({ field: "year", message: "Missing year field" });
      isOkay = false;
    }
    if (!image0) {
      setError({ field: "image", message: "Missing image field" });
      isOkay = false;
    }
    if (isOkay) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("title", name);
        formData.append("description", description);
        formData.append("status", "publish");
        formData.append("client", client);
        formData.append("month", month ? month.value : 0);
        formData.append("year", year ? year.value : 0);
        formData.append("skill", selectedSkills.join(","));
        if (!!videoUrl) formData.append("video_url", videoUrl);
        if (!!image0 && typeof image0 === "object")
          formData.append("image", image0);
        if (!!image1 && typeof image1 === "object")
          formData.append("image2", image1);
        if (!!image2 && typeof image2 === "object")
          formData.append("image3", image2);
        const editID = work ? `/${work.id}` : "";
        const result = await fetchApi(
          `/work${editID}`,
          {
            method: "post",
            body: formData,
          },
          false
        );
        console.log({ result });
        if (result.hasOwnProperty("data") && result.data.status !== 200) {
          setError({ message: result.message });
        } else {
          const notice = work ? "update" : result.status;
          history.push({
            pathname: `/designer/${user.slug}`,
            state: {
              notice: notice,
            },
          });
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
        setError({ message: "Can't create new work" });
      }
    }
  };

  return (
    <Layout title="Edit Work">
      <div className="pEditWork">
        <div className="pEditWork_content">
          <h3>{work ? "Edit project" : "Add a project"}</h3>
          <Input
            label="Name"
            required
            max={30}
            value={name}
            setValue={setName}
            error={errors.some(({ field }) => field === "name")}
          />
          <Input
            label="Client"
            required
            max={30}
            value={client}
            setValue={setClient}
            error={errors.some(({ field }) => field === "client")}
          />
          <Input
            label="Video URL (Youtube or Vimeo)"
            value={videoUrl}
            setValue={setVideoUrl}
            error={errors.some(({ field }) => field === "videoUrl")}
          />
          <div className="pEditWork_image">
            <ImageBgUpload
              label="Upload first image"
              notice="1500x1000 pixels, JPG or PNG"
              setFile={setImage0}
              currentImage={image0}
              noPreview
            />
            <ImageBgUpload
              label="Upload second image"
              notice="1500x1000 pixels, JPG or PNG"
              setFile={setImage1}
              currentImage={image1}
              noPreview
            />
            <ImageBgUpload
              label="Upload third image"
              notice="1500x1000 pixels, JPG or PNG"
              setFile={setImage2}
              currentImage={image2}
              noPreview
            />
          </div>

          <Textarea
            label="Description"
            value={description}
            setValue={setDescription}
            max={250}
            placeholder="Write some words about the project…"
          />
          <div className="pEditWork_selects">
            <Select
              label="Month"
              required
              selected={month}
              setSelected={setMonth}
              width="200px"
              placeholder="Month"
              options={months}
              error={errors.some(({ field }) => field === "month")}
            />
            <Select
              label="Year"
              required
              selected={year}
              setSelected={setYear}
              width="200px"
              placeholder="Year"
              options={years}
              error={errors.some(({ field }) => field === "month")}
            />
          </div>
          <h4>Skills</h4>
          <div className="pEditWork_list">
            {skills &&
              skills.map((skill) => (
                <Checkbox
                  key={skill.id}
                  label={skill.name}
                  checked={selectedSkills.includes(skill.id)}
                  setValue={() => selectSkill(skill.id)}
                />
              ))}
          </div>
          {errors && errors.length > 0 && (
            <ul className="pEditWork_error">
              {errors.map((err, index) => (
                <li key={index}>{err.message}</li>
              ))}
            </ul>
          )}
          <div className="pEditWork_buttons">
            <Button big outlined onClick={() => history.goBack()}>
              Cancel
            </Button>
            {!loading && (
              <Button big onClick={onPublish}>
                Publish project
              </Button>
            )}
            {loading && (
              <Button big disabled loading={loading}>
                Publish project
              </Button>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

const skillReducer = (state, skillId) =>
  state.includes(skillId)
    ? state.filter((id) => skillId !== id)
    : [...state, skillId];

const reduceError = (state, action) =>
  action ? [...state, { ...action }] : [];
